import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { authService } from '../../services/api';

export default function ForgotPassword() {
  const { t } = useTranslation('auth');
  const [email, setEmail] = useState('');
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMsg('');
    try {
      const { data } = await authService.requestPasswordReset({ email: email.trim() });
      setMsg(data.message || t('recoverFallback'));
    } catch (err) {
      setMsg(t('recoverError'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950 px-4">
      <div className="w-full max-w-md rounded-2xl border border-white/10 bg-white/[0.97] shadow-strong p-8 space-y-4">
        <h1 className="text-xl font-bold text-gray-900">{t('recoverTitle')}</h1>
        <p className="text-sm text-gray-600">{t('recoverLead')}</p>
        <form onSubmit={submit} className="space-y-3">
          <input
            className="form-input w-full"
            type="email"
            required
            placeholder={t('yourEmail')}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button type="submit" disabled={loading} className="btn btn-primary w-full">
            {loading ? t('common:sending') : t('sendLink')}
          </button>
        </form>
        {msg && <p className="text-sm text-gray-700">{msg}</p>}
        <Link to="/login" className="text-sm text-primary-700 hover:underline">
          {t('backToLogin')}
        </Link>
      </div>
    </div>
  );
}
